<script>
	import { User } from './../../models/user.js';
	import { Tabs, TabList, TabPanel, Tab } from '../../components/tabs/tabs';
	import { fly, fade } from 'svelte/transition';
	import Project from '../../models/project';

	const user = User.getUser();

	let firstCircle = true;
	let secondCircle = false;
	let thirdCircle = false; 
	let fourthCircle = false;
	let fifthCircle = false;
	let sixthCircle = false;
	let seventhCircle = false;
</script>
<section class="home-format" id="format">
	<div class="container">
		<div class="row">
			<div class="col">
				<div class="format s2-format">
					<div class="text-center format-section">
						<h1 class="format-title">
							Format
						</h1>
						<!-- <p class="format-text">
							At vero eos et dolore magnam aliquam causam ista, quae ab illo inventore veritatis et dolorem? sunt autem vel eum fugiat, quo voluptas assumenda est, necesse est, qui ratione voluptatem accusantium doloremque.
						</p> -->
					</div>
					<div class="spacer-box"></div>
					<div class="line">
						<div class="circle-step first-dot" class:active-state ={firstCircle}  on:click|preventDefault={()=>{
							firstCircle = true;
							secondCircle = false;
							thirdCircle = false; 
							fourthCircle = false;
							fifthCircle = false;
							sixthCircle = false;
							seventhCircle = false;
						}}>
							<div class="round">
								<div class="inner-circle">
									<span class="material-icons">
										sports_esports
									</span>
								</div>
							</div>
							<div class="progress-info">
								<h6>
									League Stage
								</h6>
								<!-- <p>
									7th Dec - 10th Dec  
								</p> -->
							</div>
						</div>
						<div class="circle-step second-dot" class:active-state ={secondCircle} on:click|preventDefault={()=>{
							firstCircle = false;
							secondCircle = true;
							thirdCircle = false; 
							fourthCircle = false;
							fifthCircle = false;
							sixthCircle = false;
							seventhCircle = false;
						}}>
							<div class="round">
								<div class="inner-circle">
									<span class="material-icons">
										gamepad
									</span>
								</div>
							</div>
							<div class="progress-info">
								<h6>
									Playoffs 
								</h6>
								<!-- <p>
									15th – 16th Dec 
								</p> -->
							</div>
						</div>
						<div class="circle-step third-dot" class:active-state ={thirdCircle}  on:click|preventDefault={()=>{
							firstCircle = false;
							secondCircle = false;
							thirdCircle = true; 
							fourthCircle = false;
							fifthCircle = false;
							sixthCircle = false;
							seventhCircle = false;
							}}>
							<div class="round">
								<div class="inner-circle">
									<span class="material-icons">
										star
									</span>
								</div>
							</div>
							<div class="progress-info">
								<h6>
									Grand Finals
								</h6>
								<!-- <p>
									17th – 18th Dec 
								</p> -->
							</div>
						</div>
						
					</div>
					
					<div class="format-data mr-b-3">
						<div class="row justify-content-center">
							<div class="col-md-8 col-xs-12">
								<div class="text-center">
									{#if firstCircle}
									<div in:fade="{{ duration: 1000 }}" out:fade="{{duration:0}}">
										<p >
											32 Invited teams will be divided into 4 groups (each group with 8 teams). Teams will be playing 2 Rounds of Round Robin over 2 days for 3 weeks. 
										</p>
										<p>
											The top -24 teams based on the overall standings of the week will qualify for the Playoffs. 
										</p>
										<dl>
											<dd>week - 1: 26th May 2023 - 27th May 2023</dd>
											<dd>week - 2: 2nd June 2023 - 3rd June 2023</dd>
											<dd> week - 3: 9th June 20233   - 10th June 2023</dd>
										</dl>
									</div>
									
										{:else if secondCircle}
										<div in:fade="{{ duration: 1000 }}" out:fade="{{duration:0}}">
											<p>
												24 teams will be divided into 3 groups (each group with 8 teams). Teams will be playing 2 Rounds of Double Round Robin over 1 days for 3 weeks. 
											</p>
											<p>
												The top -16 teams based on the overall standings will qualify for the Semi-Finals. 
											</p>

											<dl>
												<dd>week - 1: 28th May 2023 </dd>
												<dd>week - 2: 4th June 2023 </dd>
												<dd>week - 3: 11th June 2023 </dd>
											</dl>
										</div>
										{:else if thirdCircle}
										<div in:fade="{{ duration: 1000 }}" out:fade="{{duration:0}}">
											<p>
												16 Teams will be playing 18 matches over 3 days and the Top Team based on the overall standing at the end of the round will be crowned as Champions. 
											</p>
										<p> Date: 16th June 2023 – 18th June 2023 </p>
										</div>
									{/if}
								</div>
							</div>
						</div>
					</div>
					<!-- <div class="format-bottom text-center">
						<div class="mt-40">
							{#if $Project.registrationsOpen}
								<a href="/login" class="btn btn-primary register-btn">
									{$user.loggedOut ?  'Register Now' : 'Go to dashboard'}
								</a>
							{:else}
								<a href="/login" class="btn btn-primary register-btn">
									Go to dashboard
								</a>
							{/if}
							{#if $user.loggedOut}
							<p class="reg-help-text">Already Registered? <a href="/login">Login to your account</a></p>
							{/if}
							<span></span>
						</div>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</section>

<style>

.format-data {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	-webkit-transition: all 0.30s ease-in-out;

}

	.active-state .progress-info h6 {
		color: #3253dc;
		font-weight: 500;
		font-size: 14px;
	}

	.active-state .progress-info p {
		color: #261f14;
		font-weight: 500;
		opacity: 1;
	}

	.active-state .inner-circle {
		background: #3253dc;
		line-height: 48px;
		text-align: center;
	}

</style>
